import { styledOptions } from "../../../utils/styled-options/styled-options.es.js";
import { styled } from "@mui/material";
import MuiCard from "../../../../node_modules/@mui/material/Card/Card.es.js";
import { ONE_PIXEL_REM, Spacing } from "../../../foundations/spacing.es.js";
import { CARD_CONTAINER_BORDER_THICK, ACTION_CONTENT_BACKGROUND_COLOR, ACTION_CONTENT_BORDER_RADIUS, MIDDLE_OPACITY, MAX_OPACITY } from "../utils/product-card.constants.es.js";
import { GREY_BORDER_CARD, GREY_BORDER_CARD_HOVERED } from "../../../foundations/colors.es.js";
import { BorderStyle } from "../../../foundations/border-style.es.js";
import { Displaying } from "../../../foundations/displaying.es.js";
import { Alignment } from "../../../foundations/alignment.es.js";
import { CursorStyle } from "../../../foundations/cursor-style.es.js";
const ProductCardContainer = styled(MuiCard, styledOptions)(({
  disabled = false,
  accentColor,
  isMobile,
  theme
}) => {
  const isBorderEnabled = !!accentColor;
  let borderLeftStyle = `${ONE_PIXEL_REM} ${BorderStyle.solid} inherit`;
  if (isBorderEnabled) {
    const borderColor = disabled ? theme.palette.grey[700] : theme.palette[accentColor].main;
    borderLeftStyle = `${theme.spacing(2)} ${BorderStyle.solid} ${borderColor}`;
  }
  const opacity = disabled ? MIDDLE_OPACITY : MAX_OPACITY;
  const padding = isMobile ? `${Spacing["750"]} ${Spacing["750"]} ${Spacing["750"]} ${Spacing["1500"]}` : `${Spacing["1000"]} ${Spacing["1500"]}`;
  return {
    display: Displaying.flex,
    alignItems: Alignment.center,
    borderRadius: theme.spacing(2),
    boxShadow: Displaying.none,
    border: `${CARD_CONTAINER_BORDER_THICK} ${BorderStyle.solid} ${GREY_BORDER_CARD}`,
    padding,
    borderLeft: borderLeftStyle,
    opacity,
    "&:hover": {
      cursor: CursorStyle.pointer,
      border: `${CARD_CONTAINER_BORDER_THICK} ${BorderStyle.solid} ${GREY_BORDER_CARD_HOVERED}`,
      borderLeft: borderLeftStyle,
      "& #card-action-content": {
        background: ACTION_CONTENT_BACKGROUND_COLOR,
        borderRadius: ACTION_CONTENT_BORDER_RADIUS,
        padding: Spacing["500"]
      }
    }
  };
});
export {
  ProductCardContainer
};
//# sourceMappingURL=product-card-container.es.js.map
